import { OverlayType, showOverlay } from 'store/slice/overlay';

interface DispatchProps {
    showReviewOverlay: () => void;
}

export type Props = DispatchProps;

export const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
    showReviewOverlay: () => {
        dispatch(showOverlay(OverlayType.Review));
    },
});
